import { ChangeEvent, FC } from 'react';
import { IUserGroup } from '../../types/user';
import { updateUser } from '../../redux/actions/userActions';
import { useSwitchClinicMutation } from '../../redux/api/clinic/clinicApi';
import { useAppDispatch, useAppSelector } from '../../utils/hooks';
import styles from './ClinicToggler.module.scss';

interface Props {
  clinics: { userGroupId: string; name: string }[];
  isDisabled?: boolean;
}

const ClinicToggler: FC<Props> = ({ clinics, isDisabled }) => {
  const dispatch = useAppDispatch();
  const [switchClinic] = useSwitchClinicMutation();
  const { user } = useAppSelector((state) => state.user);
  const { clinic } = useAppSelector((state) => state.clinic);

  const switchClinicHandler = async (event: ChangeEvent<HTMLSelectElement>) => {
    const userGroupId = event.target.value;
    await switchClinic(userGroupId);

    const { userPermission } = user.userGroups.find((ug: IUserGroup) => ug.id === userGroupId);

    const updatedUser = {
      ...user,
      sourceUserGroup: {
        id: userGroupId,
        userPermission,
      },
    };
    dispatch(updateUser(null, updatedUser));
  };

  return (
    <select
      id="toggle-clinic"
      name="toggle-clinic"
      value={clinic.userGroupId}
      disabled={isDisabled}
      onChange={switchClinicHandler}
      className={styles.select}
    >
      {clinics.map((c) => (
        <option key={c.userGroupId} value={c.userGroupId}>
          {c.name}
        </option>
      ))}
    </select>
  );
};

export default ClinicToggler;
